import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../assets/images/add-business-add.png'


const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "r2xl:!tw-max-w-[61%]" }, " Here we go! Let’s get your workstation set up ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Please, add your business address", -1)
const _hoisted_5 = { class: "tw-grid tw-gap-4 tw-grid-cols-2 tw-w-full s540:!tw-flex s540:!tw-flex-col-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_AddAddressModal = _resolveComponent("AddAddressModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommonDialog, {
      isShowHeader: false,
      isShowBackButton: false,
      width: "590px",
      "max-width": "100%",
      className: ['setting_up_preview_modal']
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_icon, {
            onClick: $setup.onClickCloseModel,
            icon: "mdi-close",
            class: "close_icon"
          }, null, 8, ["onClick"]),
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              onClick: $setup.onClickCloseModel,
              variant: "secondary",
              label: "Cancel"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              onClick: $setup.onClickAddBusinessAddress,
              label: "Add Business Address",
              variant: "accent"
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }),
    ($setup.openedModel === $setup.modelName.ADDRESSMODAL)
      ? (_openBlock(), _createBlock(_component_AddAddressModal, {
          key: 0,
          onOnClose: $setup.onClickCloseModel,
          onOnCloseSuccess: $setup.onClickCloseSuccessModal
        }, null, 8, ["onOnClose", "onOnCloseSuccess"]))
      : _createCommentVNode("", true)
  ], 64))
}